module.exports = __webpack_public_path__ + "img/agent2.9d2bc639.png";